import React from 'react';
import ReactDOM from 'react-dom';

const Popup = ({ children, isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-[1000] bg-black/50">
      <div className="bg-white relative overflow-y-auto p-5 w-[80%] max-w-[400px] max-h-[70vh] shadow-[0_4px_8px_rgba(0,0,0,0.1)] rounded-lg">
        {children}
        <button className="absolute bg-transparent border-0 cursor-pointer top-[10px] right-[10px] text-2xl" onClick={onClose}>×</button>
      </div>
    </div>,
    document.getElementById('popup-root')
  );
};

export default Popup;
